import { createRequestDataSource } from '@ngneat/elf-requests';
import { select } from '@ngneat/elf';
import { clientsUnitsDetailsStore } from '@store/clients/units/details/clients-units-details.store';
import { ClientsUnit } from '@store/clients/units';

export const getClientUnitDetailsDataSource = createRequestDataSource({
  store: clientsUnitsDetailsStore,
  data$: () => clientsUnitsDetailsStore.pipe(select((state) => state as ClientsUnit)),
  requestKey: 'getClientUnitDetails',
  dataKey: 'headOffice',
});
